import React from 'react';


const
styleProps = {
    titleDiv: {
        style: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: '10px'
        }
    },
    bodyDiv: {
        style: {
            borderColor: '#DDDDDD',
            borderStyle: 'solid',
            borderWidth: '1px',
            padding: '5px'
        }
    }
}

export default class TsaWarningBanner extends React.Component {

    render() {
        return (
            <div>
                <div {...styleProps.titleDiv}>By Logging in you agree to the following:</div>    
                <div {...styleProps.bodyDiv}>
                You are accessing a U.S. Government information system, which includes: (1) this computer, 
                (2) this computer network, (3) all computers conected to this network and (4) all devices 
                and storage media attached to this network or to a computer on this network.  This Information 
                system is provided for U.S. Government-autorhized use only, Unauthorized or improper use or
                access of this system may result in disciplinary action, as well as civil and criminal 
                penalties.  By using this information system, you understand and consent to the following:
                You have no reasonable expectation of privacy when you use this information system; this 
                includes any communications or data transiting, stored on, originated from or directed to
                this information system.  At any time, and for any lawful government purpose, the government
                may monitor, intercept, search, and seize any communication or data transiting, stored on,
                originated from or directed to or from this information system.  The government may disclose
                or use any communications or data transiting, stored on, originated from or directed to or 
                from this information system for any lawful government purpose.  You are NOT authorized to 
                process classified information on this information system.  
                </div>
            </div>
        )
    }             
}